import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/**
 * POST /token/refresh {refresh_token} => {token, refresh_token, refresh_token_expiration}
 * Le refresh token est à usage unique : la réponse en contient un nouveau.
 */
export default class TokenRefreshModel extends AbstractApiModel {
  protected _path = '/token/refresh';

  @doc.string declare token: string;
  @doc.string declare refresh_token: string;
  @doc.number declare refresh_token_expiration: number;
}
